require('./bootstrap');
require('datatables.net-bs4');
import Alpine from 'alpinejs';
import sort from '@alpinejs/sort';
import './chart-loader.js';
import './map-loader.js';
window.Viewer = require('viewerjs');
window.Alpine = Alpine;
window.Maskito = require('@maskito/core');
window.MaskitoKit = require('@maskito/kit');

$.extend( $.fn.dataTable.defaults, {
	language: {
		"processing": "Procesando...",
		"lengthMenu": "Mostrar _MENU_ registros",
		"zeroRecords": "No se encontraron resultados",
		"emptyTable": "Ningún dato disponible en esta tabla",
		"info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
		"infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
		"infoFiltered": "(filtrado de un total de _MAX_ registros)",
		"search": "Buscar:",
		"infoThousands": ",",
		"loadingRecords": "Cargando...",
		"paginate": {
		"first": "Primero",
		"last": "Último",
		"next": "Siguiente",
		"previous": "Anterior"
		},
		"aria": {
		"sortAscending": ": Activar para ordenar la columna de manera ascendente",
		"sortDescending": ": Activar para ordenar la columna de manera descendente"
		},
		"buttons": {
		"copy": "Copiar",
		"colvis": "Visibilidad"
		}
	}  
});
require('select2');
require('select2/dist/js/i18n/es');
$.fn.select2.defaults.set('theme','bootstrap4');
$.fn.select2.defaults.set('language','es');

// Función global para cerrar el popup desde el iframe hijo
window.cyanClosePopup = function() {
	if (window._cyanOriginalOverflow !== undefined) {
		$('body').css('overflow', window._cyanOriginalOverflow);
		delete window._cyanOriginalOverflow;
	}
	$('#overlay').remove();
};

window.cyanPopup = function(url) {
	$('#overlay').remove();
	var ovl = $('<div id="overlay" class="overlay"><div>X</div><iframe></iframe></div>').appendTo('body');

	ovl.css({
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.5)',
		zIndex: 1000
	});

	var iframe = ovl.find('iframe');

	var w = window.innerWidth;
	var h = window.innerHeight;

	var l = Math.round(w / 10);
	if (l < 20) l = 20;
	if (l > 100) l = 100;

	var t = Math.round(h / 10);
	if (l < 20) l = 20;
	if (l > 100) l = 100;

	iframe.css( {
		position: 'absolute',
		top: t,
		left: l,
		width: (w - 2 * l)+'px',
		height: (h - 2 * t)+'px'
	});

	iframe.attr('src',url);

	// Bloquear scroll del body cuando el popup está abierto
	window._cyanOriginalOverflow = $('body').css('overflow');
	$('body').css('overflow', 'hidden');

	ovl.on('click', function(e) {
		if ($(e.target).is('#overlay'))
			window.cyanClosePopup();
	});

	// Prevenir scroll en la página padre cuando se hace scroll en el overlay
	// Esto captura el scroll que NO viene del iframe
	ovl.on('wheel', function(e) {
		e.preventDefault();
		e.stopPropagation();
	});

	// Actualizar el botón de cerrar para usar la función global
	ovl.find('div').css ({
		position: 'absolute',
		fontWeight: 'bold',
		fontSize: '40px',
		color: 'white',
		top: Math.round(l/10),
		right: 120,
		cursor: 'pointer'
	}).on('click', window.cyanClosePopup);

};

$(function() {
	// Select2

	$('.select2').not('.select2-delay').select2();

	// Flash
	
	$('#flash-overlay-modal').modal();
	$('div.alert').not('.alert-important').delay(4000).fadeTo(400,0.3);

	// Binding CyanButtons

	$('main').on('click', '.cyan-button', function() {
		var t = $(this);
		var e = t.attr('data-explanation');
		var a = t.attr('data-action');
		if (e && e != '') {
			if (!confirm('¿Confirma que desea ' + e + '?')) return;

		} 
		window['cyanButton_' + a](t);
		
	});

	// Alpine

	// Registrar plugin Sort
	Alpine.plugin(sort);

	if ($('[x-data]').not('[x-alpine-defer]').length) {
		Alpine.start();
	}

	// Manejo de popups

	$('a[data-popup]').on('click', function(e) {
		var a = $(this).closest('a');
		window.cyanPopup(a.attr('href'));
		e.preventDefault();
		return false;
	})
});

window.cyanDatatable = function(selector, params) {

	var me = $(selector).eq(0);
	var thead = me.find('thead');

	// Generar clave única para el cache basada en URL y selector
	var currentUrl = window.location.pathname + window.location.search;
	var cacheKeyBase = 'datatable_filters_' + btoa(currentUrl + '|' + selector).replace(/[^a-zA-Z0-9]/g, '_');
	var timestampKey = cacheKeyBase + '_timestamp';

	// Función para verificar si el cache es válido (menos de 300 segundos)
	function isCacheValid() {
		var timestamp = sessionStorage.getItem(timestampKey);
		if (!timestamp) return false;
		return (Date.now() - parseInt(timestamp)) < 300000; // 300 segundos = 5 minutos
	}

	// Función para actualizar timestamp del cache
	function updateCacheTimestamp() {
		sessionStorage.setItem(timestampKey, Date.now().toString());
	}

	// Función para guardar filtro en sessionStorage
	function saveFilter(columnIndex, value) {
		var key = cacheKeyBase + '_col_' + columnIndex;
		if (value && value !== '') {
			sessionStorage.setItem(key, value);
		} else {
			sessionStorage.removeItem(key);
		}
		updateCacheTimestamp();
	}

	// Función para recuperar filtro desde sessionStorage
	function loadFilter(columnIndex) {
		if (!isCacheValid()) return null;
		var key = cacheKeyBase + '_col_' + columnIndex;
		return sessionStorage.getItem(key);
	}

	var hasFilters = false;
	var filtersToApply = [];
	var debounceTimers = {}; // Almacenar timers de debounce por columna

	if (thead.is('.withFilter')) {

		var tr = thead.find('tr');

		var newTr = tr.clone(true).appendTo(thead);
		newTr.find('th').each(function(i) {
			var t = $(this);

			t.addClass('filterRow sorting_disabled');

			var title = t.text();

			if (t.is('.nofilter')) {
				t.text('');
				return;
			}

			var fv = t.attr('data-filterValues');
			var placeholder = t.attr('data-filterPlaceholder');
			if (!placeholder)
				placeholder = 'Filtrar ' + title;

			// Cargar valor desde cache si existe
			var cachedValue = loadFilter(i) || t.attr('data-filterStart');
			if (!fv) {
				// Input de texto
				t.html('<input type="text" class="filterInput" placeholder="' + placeholder + '" />');
				var input = $('input', t);

				// Precargar valor desde cache
				if (cachedValue) {
					input.val(cachedValue);
					hasFilters = true;
					filtersToApply.push({column: i, value: cachedValue});
				}

				// Función para ejecutar la búsqueda
				var performSearch = function(columnIndex, value) {
					if (table.column(columnIndex).search() !== value) {
						table
							.column(columnIndex)
							.search(value)
							.draw();
					}
					saveFilter(columnIndex, value);
				};

				// Evento keyup con debounce de 300ms
				input.on('keyup', function() {
					var value = this.value;
					var columnIndex = i;

					// Limpiar timer anterior si existe
					if (debounceTimers[columnIndex]) {
						clearTimeout(debounceTimers[columnIndex]);
					}

					// Crear nuevo timer
					debounceTimers[columnIndex] = setTimeout(function() {
						performSearch(columnIndex, value);
					}, 300);
				});

				// Evento change sin debounce (para paste, autocomplete, etc)
				input.on('change', function() {
					var value = this.value;
					var columnIndex = i;

					// Limpiar timer pendiente si existe
					if (debounceTimers[columnIndex]) {
						clearTimeout(debounceTimers[columnIndex]);
						delete debounceTimers[columnIndex];
					}

					// Ejecutar inmediatamente
					performSearch(columnIndex, value);
				});

			} else {
				// Select dropdown
				t.html('<select class="filterSelect form-select"></select>');
				var s = t.find('select');

				$('<option value=""></option>').text(placeholder).appendTo(s);

				var p = fv.split('|');
				var current = 0;

				for (var n = 0; n < p.length; n++) {
					var text = p[n];
					var prefijo = text.match(/^[0-9]+:/);
					if (prefijo) {
						current = parseInt(prefijo[0].replace(':',''));
						text = text.substring(prefijo[0].length);
					} else {
						current++;
					}

					$('<option value="'+current+'"></option>')
						.text(text)
						.appendTo(s);
				}

				// Precargar valor desde cache
				if (cachedValue) {
					s.val(cachedValue);
					hasFilters = true;
					filtersToApply.push({column: i, value: cachedValue});
				}

				s.on('change', function() {
					var value = this.value;
					if (table.column(i).search() !== value) {
						table
							.column(i)
							.search(value)
							.draw();
					}
					// Guardar en cache
					saveFilter(i, value);
				});

			}

		});
	}

	var tableConfig = $.extend(true, {},{
		processing: true,
		serverSide: true,
		orderCellsTop: true,
		bAutoWidth: false,
		searchDelay: 500
	},params);

	// Si hay filtros para aplicar, configurar deferLoading
	if (hasFilters) {
		tableConfig.deferLoading = true;
	}

	var table = me.DataTable(tableConfig);

	// Aplicar filtros cacheados si existen
	if (hasFilters) {
		for (var f = 0; f < filtersToApply.length; f++) {
			var filter = filtersToApply[f];
			table.column(filter.column).search(filter.value);
		}
		table.draw();
	}

	// Cambiar estilo de thead para las columnas de acciones
	thead.find('th.p-0').removeClass('p-0 pt-2').addClass('px-1');

	return table;

}

window.maskDocumento = function(element) {
	let el = element;
	if (typeof el === 'string') {
		el = $(el);
	}

	if (typeof el === 'object' && el.jquery) {
			if (el.length === 0) {
				return null;
			}

			el = el[0];
	}
	
	if (!(el instanceof HTMLElement) || !window.maskitoDocumento) return null;

	let mask = (typeof window.maskitoDocumento === "function") ? window.maskitoDocumento() : window.maskitoDocumento;

	const isObject = typeof mask === "object" && !(mask instanceof Array);

	const options = isObject ? {
		plugins: [ window.Maskito.maskitoInitialCalibrationPlugin() ],
		...mask
	} : {
		plugins: [ window.Maskito.maskitoInitialCalibrationPlugin() ],
		mask
	};
	

	return new window.Maskito.Maskito(el, options);

}

global.moment = require('moment');

require('tempusdominus-bootstrap-4');

require('jquery-hotkeys');
require('bootstrap-wysiwyg');

// cyanLeaflet function moved to maps.js for lazy loading

/**
 * Configura validación de teléfono con toggle nacional/extranjero
 * @param {string} telefonoSelector - Selector jQuery para el input de teléfono
 * @param {string} telefonoExtranjeroSelector - Selector jQuery para el checkbox de teléfono extranjero (opcional)
 * @param {boolean} required - Si el teléfono es requerido (default: true)
 */
window.validateTelefonoWithToggle = function(telefonoSelector, telefonoExtranjeroSelector, required) {
	if (typeof required === 'undefined') required = true;

	var telefonoMaskito = null;

	function toggleTelefonoValidation() {
		var telefonoExtranjeroEl = telefonoExtranjeroSelector ? $(telefonoExtranjeroSelector) : null;
		var isExtranjero = telefonoExtranjeroEl && telefonoExtranjeroEl.length ? telefonoExtranjeroEl.is(':checked') : false;
		var telefonoInput = $(telefonoSelector)[0];

		if (!telefonoInput) return;

		if (isExtranjero) {
			// Activar validación para teléfono internacional (+XXXXX)
			var pattern = window.patternTelefonoInternacional;
			if (!required) {
				pattern = '(' + pattern + ')|(^$)';
			}
			telefonoInput.setAttribute('pattern', pattern);
			if (required) {
				telefonoInput.setAttribute('required', 'required');
			} else {
				telefonoInput.removeAttribute('required');
			}
			telefonoInput.setAttribute('placeholder', '+12345678901 (formato internacional)');
			if (telefonoMaskito) {
				telefonoMaskito.destroy();
				telefonoMaskito = null;
			}
			// Crear Maskito para formato internacional
			telefonoMaskito = new Maskito.Maskito(telefonoInput, {
				mask: window.maskitoTelefonoInternacional,
				plugins: [ Maskito.maskitoInitialCalibrationPlugin() ]
			});
		} else {
			// Activar validación pattern y Maskito para teléfono nacional
			var pattern = window.patternTelefono;
			if (!required) {
				pattern = '(' + pattern + ')|(^$)';
			}
			telefonoInput.setAttribute('pattern', pattern);
			if (required) {
				telefonoInput.setAttribute('required', 'required');
			} else {
				telefonoInput.removeAttribute('required');
			}
			telefonoInput.setAttribute('placeholder', window.placeholderTelefono);
			if (telefonoMaskito) {
				telefonoMaskito.destroy();
				telefonoMaskito = null;
			}
			telefonoMaskito = new Maskito.Maskito(telefonoInput, {
				mask: window.maskitoTelefono,
				plugins: [ Maskito.maskitoInitialCalibrationPlugin() ]
			});
		}
	}

	// Ejecutar inmediatamente para validar contenido inicial
	toggleTelefonoValidation();

	// Ejecutar cuando cambie el checkbox (si existe)
	if (telefonoExtranjeroSelector) {
		$(telefonoExtranjeroSelector).on('change', toggleTelefonoValidation);
	}
};
